import { render, staticRenderFns } from "./PackageFormDialog.vue?vue&type=template&id=321e2826"
import script from "./PackageFormDialog.vue?vue&type=script&lang=js"
export * from "./PackageFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('321e2826')) {
      api.createRecord('321e2826', component.options)
    } else {
      api.reload('321e2826', component.options)
    }
    module.hot.accept("./PackageFormDialog.vue?vue&type=template&id=321e2826", function () {
      api.rerender('321e2826', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/package_student/components/dialog/PackageFormDialog.vue"
export default component.exports